import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M21.5456 5.11097C22.1314 5.69676 22.1314 6.6465 21.5456 7.23229L10.3026 18.4753C9.67779 19.1001 8.66473 19.1001 8.03989 18.4753L2.45375 12.8891C1.86796 12.3034 1.86796 11.3536 2.45375 10.7678C3.03953 10.182 3.98928 10.182 4.57507 10.7678L9.17126 15.364L19.4243 5.11097C20.0101 4.52518 20.9599 4.52518 21.5456 5.11097Z"
	})
});
export default SvgCheckFill;
